import { MainAppResource } from './base';

export default function FeederDiagrams({ projectCode, substationCode, diagramId }) {
  const diagramIdParam = diagramId ? `/${diagramId}` : '';

  return MainAppResource(
    `api/v3/projects/${projectCode}/substations/${substationCode}/feeder_diagrams${diagramIdParam}{/code}`
  );
}
